import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86008f1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row-span-2 text-sm sm:text-base lg:text-sm xl:text-base pt-10" }
const _hoisted_2 = { class: "font-bold text-xl sm:text-4xl lg:text-xl xl:text-4xl" }
const _hoisted_3 = { class: "py-4 sm:py-10 lg:py-4 xl:py-10" }
const _hoisted_4 = { class: "py-4 sm:py-10 lg:py-4 xl:py-10 font-bold" }
const _hoisted_5 = { class: "row-span-2 mt-10 p-6 max-w-sm h-fit bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700" }
const _hoisted_6 = { class: "font-bold mb-3" }
const _hoisted_7 = ["src"]

import DiagnosticSection from '@/components/video-diagnostic/DiagnosticSection.vue'
import { Stage } from '@/types/enums/zoom-diagnostic.enum'
import {
  permissions,
  getUserMediaContent,
} from '@/composables/video-diagnostic/useCheckPermissions'
import { useRouter } from 'vue-router'
import { computed } from 'vue'
import UAParser from 'ua-parser-js'


export default /*#__PURE__*/_defineComponent({
  __name: 'PermissionError',
  props: {
  stage: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const router = useRouter()



const permissionDeniedImg = computed(() => {
  const userAgentParser = new UAParser()
  const userAgentInfo = userAgentParser.getResult()
  const browser = userAgentInfo.browser

  if (browser.name?.includes('Chrome')) {
    return require('../../assets/video-diagnostic/permission-denied-chrome.png')
  }
  if (browser.name?.includes('Firefox')) {
    return require('../../assets/video-diagnostic/permission-denied-firefox.png')
  }
  if (browser.name?.includes('Edge')) {
    return require('../../assets/video-diagnostic/permission-denied-edge.png')
  }
  if (browser.name?.includes('Safari')) {
    return require('../../assets/video-diagnostic/permission-denied-safari.png')
  }
  return require('../../assets/video-diagnostic/permission-denied-default.png')
})

const refreshPage = () => {
  router.go(0)
}

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (!_unref(permissions))
    ? (_openBlock(), _createBlock(DiagnosticSection, {
        key: 0,
        id: _unref(Stage).PERMISSION_ERROR,
        class: _normalizeClass(
      [_unref(Stage).GET_STARTED, _unref(Stage).CHECK_PERMISSIONS].includes(__props.stage)
        ? 'opacity-0'
        : __props.stage === _unref(Stage).PERMISSION_ERROR || __props.stage === _unref(Stage).RESULTS
        ? 'block'
        : 'hidden md:block opacity-30 pointer-events-none'
    )
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h1", _hoisted_2, [
              _createVNode(_component_SvgIcon, {
                class: "error-icon",
                icon: 'error-sign',
                "inherit-fill": true,
                height: "24"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(getUserMediaContent).headline}`)), 1)
            ]),
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(`${_unref(getUserMediaContent).message}`)), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('zoom-diagnostic.permission-error.update-setting')), 1),
            _createElementVNode("button", {
              class: _normalizeClass([{ 'opacity-30 pointer-events-none': __props.stage === _unref(Stage).RESULTS }, "text-white border-2 rounded-md border-white py-2 px-4 mb-10"]),
              type: "button",
              onClick: refreshPage
            }, _toDisplayString(_ctx.$t('zoom-diagnostic.refresh-page')), 3)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('zoom-diagnostic.permission-error.permissions')), 1),
            _createElementVNode("img", {
              src: permissionDeniedImg.value,
              alt: "permission denied img for globish zoom diagnostic"
            }, null, 8, _hoisted_7)
          ])
        ]),
        _: 1
      }, 8, ["id", "class"]))
    : _createCommentVNode("", true)
}
}

})